module.exports = __webpack_public_path__ + "img/pg.3ab6c874.png";